export const calculaQtdEstPost = (
  operacao: 'soma' | 'subtracao',
  estoque: number,
  qtdEmbalagem: number,
  qtdAlteracao: number,
  tipoUnidadeAjuste: number,
): number => {
  const ajuste =
    tipoUnidadeAjuste === 1 ? qtdAlteracao * qtdEmbalagem : qtdAlteracao;

  return operacao === 'soma' ? estoque + ajuste : estoque - ajuste;
};
